import React from "react";
import Text from "../../../common/typography/text";
import MultiSelectInput from "../../../common/multi-select-input";
import { formatNumber } from "../../../common/card";

const isStockManaged = (product) =>
  product?.ManageStock === true ||
  product?.ManageStock === 1 ||
  String(product?.ManageStock ?? "").toLowerCase() === "true";

const getStockQty = (product) => {
  const parsed = Number(product?.StockQty ?? 0);
  return Number.isInteger(parsed) && parsed >= 0 ? parsed : 0;
};

const getStockStatusMessage = (product) => {
  if (!isStockManaged(product)) return "";
  const stockQty = getStockQty(product);
  if (stockQty === 0) return "Out of stock";
  if (stockQty <= 5) return `Low stock - Only ${stockQty} Qty remaining`;
  return "";
};

const ProductsContent = ({
  productCodes,
  productCodeData,
  productOptions,
  isLoadingProductOptions,
  selectedManufacturerName,
  selectedProductGroupName,
  productGroupName,
  placedByName,
  handleAddProductCode,
  handleSetQuantityChange,
  isPhone,
}) => {

  return (
    <>
      <Text variant="h1">Add Products</Text>
      {/* <div className="direct-order-review-detail-container">
        <div className="direct-order-review-detail-child-container">
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Placed By
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              <Text variant="bodyTextBold">{placedByName || "-"}</Text>
            </div>
          </div>
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Product Group
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              <Text variant="bodyText">{productGroupName || "-"}</Text>
            </div>
          </div>
        </div>
      </div> */}
      <MultiSelectInput
        type="NonAsync"
        placeholder={
          isLoadingProductOptions
            ? "Loading products..."
            : productOptions?.length > 0
              ? "Search by product code"
              : "No products available"
        }
        value={productCodes}
        setValue={handleAddProductCode}
        options={productOptions}
        labelKey="label"
        labelValue="value"
      />
      {selectedManufacturerName ? (
        <Text variant="tinyText" color="lightText">
          Showing products from {selectedManufacturerName}
          {selectedProductGroupName ? ` in ${selectedProductGroupName}` : ""}
        </Text>
      ) : null}
      {productCodeData?.map((product) => {
        const quantity = Number(product?.Quantity ?? 0);
        const stockMessage = getStockStatusMessage(product);
        const isOutOfStock = isStockManaged(product) && getStockQty(product) === 0;
        return (
          <div
            key={product?.ProductID || product?.ProductCode}
            className="quick-order-2of2-detail-container"
            style={isPhone ? { flexWrap: "wrap" } : {}}
          >
            <div className="quick-order-2of2-detail-left-container">
              <div className="quick-order-2of2-detail-left-image-container">
                <Text variant="bodyText" color="primaryColor">
                  {product?.ProductCode}
                </Text>
              </div>
              <div className="quick-order-2of2-detail-left-text-container">
                <Text color="lightText">{product?.ProductName}</Text>
                <Text>${formatNumber(product?.Price).split(".")[0]}</Text>
                {stockMessage ? (
                  <span className="direct-order-stock-alert">{stockMessage}</span>
                ) : null}
              </div>
            </div>
            <div className="quick-order-2of2-detail-left-container">
              <Text variant="numbersMedium">
                $
                {
                  formatNumber(product?.Price * (product?.Quantity || 0)).split(
                    ".",
                  )[0]
                }
                <Text variant="numbersMedium" color="lightText">
                  .
                  {
                    formatNumber(
                      product?.Price * (product?.Quantity || 0),
                    ).split(".")[1]
                  }
                </Text>
              </Text>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                className="direct-order-quantity-input"
                value={quantity}
                disabled={isOutOfStock}
                onChange={(e) => {
                  const digitsOnly = e.target.value.replace(/[^0-9]/g, "");
                  handleSetQuantityChange(product, digitsOnly);
                }}
                style={{ width: 64, height: 32, textAlign: "center", border: "1px solid var(--strokeLight)", fontSize: 16 }}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ProductsContent;
